import {
  deleteProviderReview,
  fetchProviderReviews,
} from "@/api/providerDashboard";

export default {
  async loadReviews() {
    this.loading = true;
    try {
      const res = await fetchProviderReviews({ limit: 50 });
      if (res.data.status === 200) this.reviews = res.data.data;
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false;
    }
  },
  async handleDeleteReview(reviewId) {
    try {
      await this.$confirm(
        "삭제된 리뷰는 복구할 수 없습니다. 리뷰를 삭제하시겠습니까?",
        {
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          type: "warning",
        }
      );
    } catch (error) {
      return;
    }

    this.deletingReviewId = reviewId;
    try {
      await deleteProviderReview(reviewId);
      if (this.replyTarget === reviewId) {
        this.replyTarget = null;
        this.replyContent = "";
        this.isEditing = false;
      }
      this.$message.success("리뷰가 삭제되었습니다.");
      await this.loadReviews();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        "리뷰 삭제에 실패했습니다.";
      await this.$alert(message, { confirmButtonText: "확인" });
    } finally {
      this.deletingReviewId = null;
    }
  },
};
